import React from "react";
import ScreeningQuestionTwo from "../shared/ScreeningQuestionTwo";
import { handleStoreScreeningScheduledDetails } from "../public/CommonAPIHelper";

const ScreeningScheduledQuestionTwoUI = () => {
  return (
    <ScreeningQuestionTwo
      questionText="Approximately when is your screening scheduled?"
      backRoute="./1"
      nextRoute="/screeningscheduled/3"
      onSubmitHandler={handleStoreScreeningScheduledDetails}
      showDayPicker={true}
    />
  );
};

export default ScreeningScheduledQuestionTwoUI;
